import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';
import Pagination from 'shared/models/pagination';

import ReadIntercomIpRoomUnitsResponse from 'features/systems/ip-unit/domain/models/read-intercom-ip-room-units-response';

const baseUrl = '/api/v1/System';

enum SystemQueryPaths {
  ReadIntercomIpRoomUnits = 'ReadIntercomIpRoomUnits',
}

const readIntercomIpRoomUnits = async (
  axiosInstance: AxiosInstance,
  gatewayId: string,
  searchQuery: string,
  pagination: Pagination,
  signal?: AbortSignal,
): Promise<ReadIntercomIpRoomUnitsResponse> => {
  const response = await axiosInstance.post(
    `${baseUrl}/${SystemQueryPaths.ReadIntercomIpRoomUnits}`,
    { gatewayId, searchQuery, pagination },
    { signal },
  );
  return response.data;
};

export const useReadIntercomIpRoomUnits = (gatewayId: string | undefined, searchQuery: string, pagination: Pagination) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [SystemQueryPaths.ReadIntercomIpRoomUnits, gatewayId, searchQuery, pagination],
    queryFn: ({ signal }) => readIntercomIpRoomUnits(authenticatedInstance, gatewayId ?? '', searchQuery, pagination, signal),
    enabled: gatewayId !== undefined,
  });
};
